<template>
  <div class="remove-btn text-12" @click="handleShowDeleteDialog">
    <icon-delete />
    <span class="ml-2">{{ text }}</span>
  </div>
</template>

<script>
import iconDelete from '~/assets/svg/icon/iconDelete.svg'
export default {
  name: 'RemoveBtn',
  components: {
    iconDelete
  },
  props: {
    clickFun: {
      type: [Function, String],
      default: ''
    },
    text: {
      type: String,
      default: '删除区块'
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleShowDeleteDialog() {
      if (this.clickFun) {
        this.clickFun()
      } else {
        this.SiteMenu.openDeleteBlockDialog()
      }
    }
  }
}
</script>

<style lang="less">
.remove-btn {
  border-radius: 8px;
  background: rgba(255, 77, 79, 0.1);
  border: 1px solid rgba(255, 77, 79, 0.2);
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff4d4f;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 13px;
  font-weight: 500;
  
  span {
    letter-spacing: 0.5px;
  }
  
  svg {
    transition: transform 0.3s ease;
  }

  &:hover {
    background: linear-gradient(135deg, rgba(255, 77, 79, 0.9), rgba(255, 120, 117, 0.9));
    border-color: transparent;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);
    
    svg {
      transform: rotate(-10deg) scale(1.1);
      path {
        fill: white !important;
      }
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(255, 77, 79, 0.2);
  }
}
</style>
